<template>
    <div class="about-us-main">
        <div class="content">
           <div class="commitment-content" ref="commitment">
                <div class="resources commitment-content-common">
                    <div class="resources-left" :class="{'animateRight':isAnimateX}"><img :class="{'banner-fade-in':isAnimateX}" loading="lazy"  :src="commitmentInfo.resourcesImg" alt=""></div>
                    <div class="resources-right" :class="{'animateX':isAnimateX}">
                        <div class="resources-left-title title-common">{{ commitmentInfo.resourcesTitle }}</div>
                        <div class="resources-left-desc desc-common">{{ commitmentInfo.resourcesDesc }}</div>
                    </div>
                </div>
                <div class="services commitment-content-common">
                    <div class="resources-left" :class="{'animateX':isAnimateX}"><img loading="lazy"  :src="commitmentInfo.servicesImg" alt="" :class="{'banner-fade-in':isAnimateX}"></div>
                    <div class="resources-right" :class="{'animateRight':isAnimateX}">
                        <div class="title-common">{{ commitmentInfo.servicesTitle }}</div>
                        <div class="li desc-common" v-for="item in commitmentInfo.servicesDescList" :key="item.id">
                            <span></span><div class="li-desc">{{ item.desc }}</div>
                        </div>
                    </div>
                </div>
           </div>
           <div class="Customer-Introduction-content">
                <div class="Customer-Introduction-center" ref="customerIntroduction">
                    <div class="left">
                        <div class="left-title">What Our Customer's Say About Us </div>
                        <div class="desc">We have received positive reviews from different users in multiple countries.</div>
                        <div class="evaluate">
                            <div class="evaluate-item" v-for="(item,index) in 5" :key="index">
                                <img loading="lazy"  src="../../../static/img/aboutUs/Vector.png" alt="">
                            </div>
                        </div>
                        <div class="message">“I've traveled with bbgmove several times, and each time has been a unique and unforgettable experience.”</div>
                        <div class="userInfo">
                            <img loading="lazy"  src="../../../static/img/aboutUs/Ellipse 52.png" alt="">
                            <div class="userInfo-content">
                                <div class="userInfo-name">Smith Johnson</div>
                                <div class="userInfo-country">London, United Kingdom</div>
                            </div>
                        </div>
                    </div>
                    <div class="right" :class="{'banner-fade-in':fadeIn}">
                        <img loading="lazy"  src="../../../static/img/aboutUs/Ellipse 53.png" alt="" class="img1" @click="goToImg(1)">
                        <img loading="lazy"  src="../../../static/img/aboutUs/Ellipse 54.png" alt="" class="img2" @click="goToImg(2)">
                        <img loading="lazy"  src="../../../static/img/aboutUs/Ellipse 57.png" alt="" class="img3" @click="goToImg(3)">
                        <img loading="lazy"  src="../../../static/img/aboutUs/Ellipse 55.png" alt="" class="img4" @click="goToImg(4)">
                        <img loading="lazy"  src="../../../static/img/aboutUs/Ellipse 56.png" alt="" class="img5" @click="goToImg(5)">
                        <img loading="lazy"  src="../../../static/img/aboutUs/Ellipse 52 (2).png" alt="" class="img6" @click="goToImg(6)">
                        <img loading="lazy"  src="../../../static/img/aboutUs/Ellipse 58.png" alt="" class="img7" @click="goToImg(7)">
                    </div>
                </div>
           </div>
           <div class="Service-Standards-content">
                <div class="Service-Standards-center" :class="{'banner-fade-in':isAnimate}">
                        <div class="Service-Standards-center-content" ref="serviceStandards">
                            <div class="top" :class="{'animate':isAnimate}">
                                <div class="top-title">ONLY THE BEST QUALITY FOR YOU</div>
                                <div class="top-desc">You deserve the ultimate best quality for your memorable experiences.</div>
                            </div>
                            <div class="bottom" :class="{'animate':isAnimate}">
                            <div class="bottom-item" v-for="item in evaluateList" :key="item.id">
                                <div class="info">
                                    <div class="bottom-item-num">{{ item.num }}</div>
                                        <div class="bottom-item-title">{{ item.title }}</div>
                                    </div>
                                    <div class="bottom-item-line"></div>
                                    </div>
                                </div>
                            </div>
                        <div>
                    </div>
                </div>
           </div>
           <div class="Brandon-Shaw-content" ref="brandonShaw">
            <div class="Brandon-Shaw-content-center" :class="{'banner-fade-in':isBbrandonShaw}">
               <div class="Brandon-Shaw-content-info">
                    <div class="left" :class="{'animate':isBbrandonShaw}">
                        <img loading="lazy"  src="../../../static/img/logo/aboutUsLogo.png" alt="">
                        <div class="left-content">
                            <div class="left-top">Brandon Shaw</div>
                            <div class="left-bottom">Founder & CEO</div>
                        </div>
                    </div>
                    <div class="right" :class="{'animate':isBbrandonShaw}">“Our goal is to provide the best and most comprehensive group tour platform, enabling users to match with the most suitable travel agency.”</div>
               </div>
            </div>
           </div>
           <div class="Questions-content">
                <div class="Questions-center">
                    <div class="Questions-center-title">
                        FAQ
                    </div>
                    <div class="Questions-center-desc">
                    What our clients usually asked about our services and tours.
                    </div>
                    <div class="Questions-center-list">
                        <CustomCollapseItem v-for="item in customCollapseList" :desc1="item.desc1" :id="Number(item.id)" :key="item.id" :title="item.title" :desc="item.desc"></CustomCollapseItem>
                    </div>
                </div>
            </div>
            <div class="our-partnerships">
                <div class="our-partnerships-center">
                    <div class="our-partnerships-top">
                        <div class="our-partnerships-title">{{ourPartnershipsInfo.title}}</div>
                        <div class="our-partnerships-desc">{{ourPartnershipsInfo.desc}}</div>
                    </div>
                    <div class="bottom">
                        <div class="bottom-item" v-for="item in ourPartnershipsInfo.list" :key="item.id" v-show="viewportWidth > 799">
                            <img loading="lazy"  :src="item.img" alt="">
                        </div>
                         <partnershipsComponent :list="ourPartnershipsInfo.list" v-show="viewportWidth <= 799"></partnershipsComponent>
                    </div>
                </div>
            </div>
           
            <div class="Contact-Us-content" ref="contactUs">
                <div class="start-your-travel">
                    <div class="content-center" :class="{'banner-fade-in':contactUsIsAnimate}">
                        <div class="info-center">
                            <div class="top" :class="{'animate':contactUsIsAnimate}">{{contactUsInfo.title1}}</div>
                            <div class="top" :class="{'animate':contactUsIsAnimate}">{{contactUsInfo.title2}}</div>
                            <div class="all-bottom" :class="{'animate':contactUsIsAnimate}">
                                <div class="center">
                                    {{contactUsInfo.desc}}
                                </div>
                                <div class="bottom" @click="contactUsEvent">
                                    <div class="btn">{{contactUsInfo.btn}}</div>
                                        <img loading="lazy"  src="../../../static/img/home/back.png" alt="">
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import commitmentData from '/js/aboutUs/commitment/commitment.js'
import CustomCollapseItem from '/components/pc/collapseComponent/collapseComponent.vue'
import ourPartnerships from '/js/aboutUs/ourPartnerships/ourPartnerships.js'
import customCollapse from '/js/aboutUs/customCollapseList/customCollapseList.js'
import partnershipsComponent from '/components/phone/aboutUs/partnershipsComponent.vue'
export default {
     components: {
        CustomCollapseItem,
        partnershipsComponent
    },
    data(){
        return {
            commitmentInfo:{},
            evaluateList:[
                {id:1,num:'98%',title:'Satisfaction rate'},
                {id:2,num:'2.5K+',title:'Active Members'},  
                {id:3,num:'250+',title:'Tour Destination'},
                {id:4,num:'140+',title:'Destination'}
            ],
            customCollapseList:customCollapse.customCollapseList,
            ourPartnershipsInfo:ourPartnerships.ourPartnershipsInfo,
            contactUsInfo:{
                title1:"Have a question?",
                title2:"Our team is happy to assist you",
                desc:"Ask about our products, pricing, implementation, or anything else. Our highly trained reps are standing by, ready to help.",
                btn:"Contract Us",
                phone:"Or call +12 3456 7890",
            },
            isAnimate:false,
            fadeIn:false,
            isBbrandonShaw:false,
            isAnimateX:false,
            contactUsIsAnimate:false,
            viewportWidth:0,
        }
    },
    created(){
        this.commitmentInfo = commitmentData.commitmentInfo
    },
    mounted(){
        this.viewportWidth = window.innerWidth;
        window.addEventListener('resize', this.handleResize);
         // 创建 IntersectionObserver 实例并观察两个元素
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            // 根据 entry.target 判断是哪个元素触发了观察
            if (entry.isIntersecting) {
              if (entry.target == this.$refs.serviceStandards) {
                // 如果 .Popular-products 元素进入视口，执行对应的动画
                this.isAnimate = true;
                this.$al // 执行动画的逻辑
              }else if (entry.target == this.$refs.commitment) {
                // 如果 .userContent 元素进入视口，执行不同的动画
                this.isAnimateX = true
              }else if (entry.target == this.$refs.brandonShaw) {
                this.isBbrandonShaw = true
              }else if (entry.target == this.$refs.customerIntroduction) {
                this.fadeIn = true
              }else if (entry.target == this.$refs.contactUs) {
                this.contactUsIsAnimate = true
              } 
          
          

              // 停止观察，确保动画只触发一次
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.1 }); // 触发时，至少 10% 的元素进入视口

        // 开始观察两个元素
        observer.observe(this.$refs.serviceStandards); // 观察 Popular-products 元素
        observer.observe(this.$refs.commitment); // 观察 userContent 元素
        observer.observe(this.$refs.brandonShaw); // 观察 userContent 元素
        observer.observe(this.$refs.customerIntroduction); // 观察 userContent 元素
        observer.observe(this.$refs.contactUs); // 观察 userContent 元素
    },
    methods:{
        handleResize() {
        this.viewportWidth = window.innerWidth;
      },
        contactUsEvent(){
        this.$router.push({
          path:'/bookNow',
        })
      }
    }
}
</script>
<style scoped lang="scss">
@import '/style/pc/aboutUs/aboutUs.scss';
@import '/style/phone/aboutUs/aboutUs.scss';
@import '/style/pc/common/animate.scss';
@import '/style/pc/common/animateX.scss';
@import '/style/pc/common/animateRight.scss';
@import '/style/pc/common/fadeIn.scss';
</style>